import axios from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';
import { ProfileType } from 'types/shared/profile-type.enum';
import { ProfileListItem } from 'views/profiles-strategies/features/profiles/types/profile-list-item.type';

// this has the api root of planning and prognosis, yet it is exclusively used in feed strategies section?

// GET
// /ewosapi/v2/planandprognosis/profile/{profileType}/{type}/{marketId}
export const getProfilesByType = async (profileType: ProfileType, ownerType: OwnerType, id: string): Promise<ProfileListItem[]> => {
  const res = await axios.get<ProfileListItem[]>(`/ewosapi/v2/planandprognosis/profile/${profileType}/${ownerType}/${id}?filter=all`);
  return res.data;
};
